import { TextStyle } from 'react-native';
import RegularText from "./RegularText";


export class BoldText extends RegularText {
    addStyles: (() => TextStyle) = () => ({fontFamily:'NunitoBold'});
}

export default BoldText;